import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.pages.CustomizeUnitTypesPage`

export default defineMessages({
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  customizeUnitTypesTitle: {
    id: `${scope}.customizeUnitTypesTitle`,
    defaultMessage: 'Customize unit types',
  },
})
